export class ML
{
    sender: string; 
    subject: string; 
    content : string;
    senton : Date; 
senderemail : string;
receipientemail : string;
}